/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminEnableUserOptions, AdminEnableUserResponses } from '../../models/AdminEnableUser'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Enable User
 * {@link /admin/users/:user_id/enable}
 */
export function adminEnableUser<ThrowOnError extends boolean = true>(options: Options<AdminEnableUserOptions, ThrowOnError>): Promise<UnwrappedResult<AdminEnableUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/users/{user_id}/enable', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminEnableUserResponses, ThrowOnError>>
}
